/*=========================================================================================
  File Name: getters.js
  Description: Vuex Store - getters
==========================================================================================*/


const getters = {
    // ////////////////////////////////////////////
    // AUTH
    // ////////////////////////////////////////////

    isLoggedIn: state => state.token,
    authStatus: state => state.status,

	// COMPONENT
    // vx-autosuggest
	// staredPages: state => state.staredPages,
};

export default getters
